import { render, staticRenderFns } from "./RelationsTable.vue?vue&type=template&id=22a6ad69&scoped=true"
import script from "./RelationsTable.vue?vue&type=script&lang=js"
export * from "./RelationsTable.vue?vue&type=script&lang=js"
import style0 from "./RelationsTable.vue?vue&type=style&index=0&id=22a6ad69&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a6ad69",
  null
  
)

export default component.exports